import React, { Component } from 'react';
import rightGreen from '../../assets/right-green.png'

export default class RightAndObligation extends Component {
  render() {
    return (
      <section id="hak-dan-kewajiban-pemilik-sertifikat-elektronik">
        <p style={{fontSize: '18px', color: '#0085C7', fontWeight: '600', marginBottom: '25px'}}>Hak dan Kewajiban Pemilik Sertifikat Elektronik</p>
        <div class="row">
          <div class="col-lg-5 col-md-6 col-sm-12 col-12">
            <table class="table-borderless table-hak w-100 text-white">
              <tr>
                <td>Hak Pemilik</td>
              </tr>
              <tr>
                <td>
                  <div class="d-flex mb-4">
                    <img src={rightGreen} alt="right-green" style={{width: '10px', height: '10px', marginTop: '3px', marginRight: '20px'}}/>
                    <div>
                      <p style={{fontSize: '14px', fontWeight: '600', marginBottom: '5px'}}>Memperpanjang</p>
                      <p style={{fontSize: '13px'}}>Masa Berlaku Sertifikat Elektronik</p>
                    </div>
                  </div>
                  <div class="d-flex mb-4">
                      <img src={rightGreen} alt="right-green" style={{width:'10px', height:'10px', marginTop: '3px', marginRight: '20px'}}/>
                    <div>
                      <p style={{fontSize: '14px', fontWeight: '600', marginBottom: '5px'}}>Memblok</p>
                      <p style={{fontSize: '13px'}}>Sertifikat Elektronik yang dimilikinya</p>
                    </div>
                  </div>
                  <div class="d-flex mb-4">
                    <img src={rightGreen} alt="right-green" style={{width:'10px', height:'10px', marginTop: '3px', marginRight: '20px'}}/>
                    <div>
                      <p style={{fontSize: '14px', fontWeight: '600', marginBottom: '5px'}}>Mendapatkan Edukasi</p>
                      <p style={{fontSize: '13px'}}>Dalam Menggunakan Sertifikat Elektronik dari PSrE</p>
                    </div>
                  </div>
                  <div class="d-flex">
                    <img src={rightGreen} alt="right-green" style={{width:'10px', height:'10px', marginTop: '3px', marginRight: '20px'}}/>
                    <div>
                      <p style={{fontSize: '14px', fontWeight: '600', marginBottom: '5px'}}>Mencabut</p>
                      <p style={{fontSize: '13px'}}>Sertifikat Elektronik yang dimilikinya</p>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-lg-5 col-md-6 col-sm-12 col-12">
            <table class="table-borderless table-hak w-100 text-white">
              <tr>
                <td>Kewajiban Pemilik</td>
              </tr>
              <tr>
                <td>
                  <div class="d-flex mb-5">
                    <img src={rightGreen} alt="right-green" style={{width:'10px', height:'10px', marginTop: '3px', marginRight: '20px'}}/>
                    <div>
                      <p style={{fontSize: '14px', fontWeight: '600', marginBottom: '5px'}}>Menggunakan</p>
                      <p style={{fontSize: '13px'}}>Sertifikat Elektronik sesuai dengan kontrak langganan (subscriber agreement)</p>
                    </div>
                  </div>
                  <div class="d-flex mb-4">
                    <img src={rightGreen} alt="right-green" style={{width:'10px', height:'10px', marginTop: '3px', marginRight: '20px'}}/>
                    <div>
                      <p style={{fontSize: '14px', fontWeight: '600', marginBottom: '5px'}}>Menjaga Kerahasiaan</p>
                      <p style={{fontSize: '13px'}}>dan bertanggung jawab atas pemakaian Sertifikat Elektronik yang dimilikinya</p>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </section>
    )
  }
}
